import { SessionsDataManager } from './sessionsDataManager';

class SessionsManager {
    private sessionsDataManager = new SessionsDataManager();

    saveConfigWithInput(config: string, input: string) {
        return this.sessionsDataManager.saveSessionConfigWithInput(config, input);
    }

    getConfigWithInput() {
        return this.sessionsDataManager.getSessionData();
    }
}

export const sessionsManager = new SessionsManager();
